module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/process/process.component.css
// module id = ./src/app/components/process/process.component.css
// module chunks = main